import { render } from "./pb-participantstext.vue?vue&type=template&id=13e0dc57"
import script from "./pb-participantstext.vue?vue&type=script&lang=js"
export * from "./pb-participantstext.vue?vue&type=script&lang=js"

import "./pb-participantstext.vue?vue&type=style&index=0&id=13e0dc57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__